import { IUser } from "./model/user";
// import { IStaff } from "./model/staff";

export const Configuration = {
  getTokenUrl(user: IUser) {
    return `grant_type=password&username=${user.username}&
        password=${user.password}&
        id=${user.id}&
        loginSource=admission`;
  },
  // 9LMFUQS6C7
  // 9012043721
  apiData: {
    // serverUrl: "https://localhost:44337/",
    // Testing Svr
    // serverUrl:'http://45.222.48.113:81/',
    // Live
    serverUrl: "https://portal.umat.edu.gh/api-v1/live/admissions/",
    loginSource: "loginSource",
    apiPath: {
      staff: "api/Staff/",
    },
  },
  localStorageData: {
    token: "token",
    applicantType: "applicantType",
    applicaintData: "applicaintData",
    loginUserData: "loginUserData",
    guardianData: "guardianData",
    hasReadHelp: "hasReadHelp",
    pdfPath: "pdfPath",
    applicantProgrammeOfChoice: "applicantProgrammeOfChoice",
    progressMessageData: "progressMessageData",
    applicantExaminationData: "applicantExaminationData",
    campusId: "campusId",
  },
  dialogMessage: {
    saveCompleleted: "You have successfull saved",
  },
  routerData: {
    login: {
      path: "login",
      text: "Login",
      link: "/login",
    },
    forgetPassword: {
      path: "forget-password",
      text: "Forget Password",
      link: "/forget-password",
    },
    resetPassword: {
      path: "reset-password",
      text: "Reset Password",
      link: "/reset-password",
    },
    changePassword: {
      path: "change-password",
      text: "Change Password",
      link: "/change-password",
    },
    resetPasswordConfirmation: {
      path: "reset-password-confirmation",
      text: "Reset Password Confirmation",
      link: "/reset-password-confirmation",
    },
    registerAccount: {
      path: "register-account",
      text: "Register",
      link: "/register-account",
    },
    lockAccount: {
      path: "lock-account",
      text: "Lock Account",
      link: "/lock-account",
    },
  },
};
